var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainBodyBg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 1230,
    viewBox: "0 0 430 1230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_48)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 1230,
    fill: "url(#paint0_linear_1_48)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_1_48)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.084 392.985C345.913 395.394 374.784 382.523 398.586 397.142C427.769 415.066 454.741 443.417 455.92 477.644C457.119 512.448 432.109 542.887 404.33 563.889C379.979 582.3 348.612 581.976 318.084 581.856C287.738 581.736 253.333 585.294 232.516 563.212C211.956 541.401 221.527 507.571 219.845 477.644C217.983 444.503 197.183 403.555 222.327 381.887C247.632 360.08 284.805 390.105 318.084 392.985Z",
    fill: "#8F40D3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_1_48)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.652 689.568C152.439 696.116 170.074 745.039 196.643 779.21C218.023 806.705 250.077 831.508 246.993 866.201C244.008 899.781 208.271 917.325 182.439 938.988C160.075 957.745 137.854 973.858 109.652 981.383C67.3965 992.657 15.7247 1021.95 -16.1114 991.964C-47.8475 962.073 -13.9492 909.778 -12.6403 866.201C-11.4075 825.159 -32.1496 781.531 -8.77676 747.772C17.2524 710.177 64.4518 682.651 109.652 689.568Z",
    fill: "#4D8CFF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_f_1_48)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.898 -232.863C483.075 -223.731 497.624 -151.471 527.474 -103.012C547.238 -70.9262 558.308 -38.6186 568.837 -2.43491C587.008 60.0168 644.187 125.344 610.022 180.689C575.617 236.422 490.982 241.026 426.898 227.498C371.733 215.853 343.191 160.587 307.61 116.853C277.605 79.9735 243.549 44.9623 239.827 -2.43491C235.826 -53.3778 255.067 -102.386 287.275 -142.058C323.651 -186.866 369.931 -242.123 426.898 -232.863Z",
    fill: "#FF4DA6"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_48)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.123,
    y: 1216,
    width: 134,
    height: 5,
    rx: 2.5,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_48",
    x: -504.8,
    y: -340.8,
    width: 1675.56,
    height: 1637.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 357.4,
    result: "effect1_foregroundBlur_1_48"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_48",
    x: -744.435,
    y: -26.3,
    width: 1706.43,
    height: 1746.17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 357.4,
    result: "effect1_foregroundBlur_1_48"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1_48",
    x: -475.497,
    y: -948.689,
    width: 1810.99,
    height: 1897.38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 357.4,
    result: "effect1_foregroundBlur_1_48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_48",
    x1: 215,
    y1: 0,
    x2: 215,
    y2: 1230,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD4EA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 1230,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 5,
    fill: "white",
    transform: "translate(148.123 1216)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBodyBg1);
export default __webpack_public_path__ + "static/media/main-body-bg1.ecdd6a9048fd479d7df979a2497b1ad6.svg";
export { ForwardRef as ReactComponent };